import React, { useState } from 'react';

const FAQItem = ({ question, answer, id }) => {
  const [isOpen, setIsOpen] = useState(false);

  const toggleAnswer = () => {
    setIsOpen(!isOpen);
  };

  return (
    <div className="accordion-item">
      <button
        className={`accordion-button ${isOpen ? 'show' : ''}`}
        type="button"
        onClick={toggleAnswer}
        aria-expanded={isOpen}
      >
        {question}
      </button>

      <div id={id} className={`accordion-collapse collapse ${isOpen ? 'show' : ''}`} data-bs-parent="#sf-faq-accordion">
        <div className="accordion-body">
          {answer}
        </div>
      </div>
    </div>
  );
};

export default FAQItem;
